import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BarbadosFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14322'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14322)'>
				<rect
					width='20'
					height='14'
					fill='url(#paint0_linear_2332_14322)'
				/>
				<rect
					x='9.52344'
					width='10.4762'
					height='14'
					fill='#08379D'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H6.66667V0H0V14Z'
					fill='#08379D'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 14H13.3327V0H6.66602V14Z'
					fill='#FFCC50'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.74073 4.60263C9.87483 4.40939 10.1615 4.41207 10.2919 4.60778L10.7046 5.22682C10.8109 5.38635 10.6966 5.60001 10.5049 5.60001C10.3626 5.60001 10.2516 5.72295 10.266 5.86442L10.4466 7.63385C10.464 7.80396 10.6072 7.93334 10.7782 7.93334H10.8183C10.9049 7.93334 10.9881 7.89963 11.0503 7.83934L11.3282 7.56991C11.393 7.50713 11.4295 7.42078 11.4295 7.33058V6.66882C11.4295 6.58217 11.3947 6.49917 11.3328 6.43852C11.16 6.26915 11.2283 5.97685 11.4583 5.90171L11.847 5.77475C12.0878 5.69609 12.3249 5.90413 12.2781 6.15309L11.9641 7.82665C11.9511 7.89599 11.9164 7.95941 11.865 8.00779L11.0496 8.77596C10.9878 8.83423 10.906 8.86668 10.8211 8.86668H10.8105C10.6264 8.86668 10.4772 9.01592 10.4772 9.20001V9.46668C10.4772 9.65077 10.3279 9.80001 10.1438 9.80001H9.85811C9.67402 9.80001 9.52478 9.65077 9.52478 9.46668V9.20001C9.52478 9.01592 9.37554 8.86668 9.19145 8.86668H9.18469C9.09745 8.86668 9.01369 8.83248 8.95138 8.77141L8.1691 8.00477C8.12159 7.95822 8.0891 7.89852 8.0758 7.83335L7.7346 6.16145C7.68348 5.91098 7.92171 5.69856 8.16471 5.77794L8.54359 5.90171C8.77361 5.97685 8.84198 6.26915 8.66916 6.43852C8.60727 6.49917 8.5724 6.58217 8.5724 6.66882V7.33058C8.5724 7.42078 8.60895 7.50713 8.67371 7.56991L8.95162 7.83934C9.01381 7.89963 9.09703 7.93334 9.18365 7.93334H9.22373C9.39472 7.93334 9.53798 7.80396 9.55534 7.63385L9.73628 5.86068C9.75051 5.72121 9.64105 5.60001 9.50085 5.60001C9.30984 5.60001 9.19754 5.38538 9.30644 5.22845L9.74073 4.60263Z'
					fill='#262626'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_14322'
					x1='0'
					y1='0'
					x2='0'
					y2='14'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#1132C7' />
					<stop
						offset='1'
						stopColor='#0522A5'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default BarbadosFlagIcon;
